/* ==========================================================================
   AKZERN YAPI — scroll-controlled hero (frame-by-frame, canvas)
   Decodes hero video into a downscaled frame cache in-browser, then scrubs
   forward/backward with scroll over a pinned section.
   Production path: drop a real WebP sequence at
   assets/akzern/hero/frames/frame-0001.webp … (SEQ.enabled = true, aktif).
   Fallbacks: prefers-reduced-motion → static poster; mobile → fewer frames;
   decode failure/timeout → static poster + normal scroll.
   ========================================================================== */
(function(){
  const SEQ = {
    enabled:true, ext:".webp",
    path:(window.ASSET_BASE||"")+"frame-", count:120,
    pathMobile:(window.ASSET_BASE||"")+"m-frame-", countMobile:48
  };
  const VIDEO_SRC = (window.ASSET_BASE||"")+"hero-salon.mp4"; // fallback if SEQ disabled

  function init(){
    const cine=document.getElementById('cine'); if(!cine) return;
    const canvas=document.getElementById('heroCanvas');
    const poster=document.getElementById('heroPoster');
    const caps=[].slice.call(cine.querySelectorAll('.cine__cap[data-range]')).map(function(el){var r=el.dataset.range.split(',');return{el:el,a:+r[0],b:+r[1],last:el.classList.contains('cine__cap--final')};});
    const finalBtns=cine.querySelector('.cine__finalbtns');
    const hint=document.getElementById('cineHint');
    const loading=document.getElementById('heroLoading');
    const loadingBar=loading?loading.querySelector('span'):null;
    if(!canvas) return;
    const ctx=canvas.getContext('2d',{alpha:false});
    const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile=matchMedia('(max-width:680px)').matches;
    const dpr=Math.min(window.devicePixelRatio||1, 1.6);
    const N = isMobile?48:96;
    const DECODE_W = isMobile?854:1440;

    let frames=[], ready=false;

    function fit(){
      const w=cine.clientWidth, h=window.innerHeight;
      canvas.width=Math.round(w*dpr); canvas.height=Math.round(h*dpr);
      canvas.style.width=w+'px'; canvas.style.height=h+'px';
    }
    function drawBmp(bmp){
      if(!bmp) return;
      const cw=canvas.width, ch=canvas.height, iw=bmp.width, ih=bmp.height;
      const s=Math.max(cw/iw, ch/ih), w=iw*s, h=ih*s;
      ctx.drawImage(bmp,(cw-w)/2,(ch-h)/2,w,h);
    }
    function progress(){
      const total=cine.offsetHeight-window.innerHeight;
      return Math.max(0,Math.min(1,(-cine.getBoundingClientRect().top)/(total||1)));
    }
    function render(){
      const p=progress();
      if(ready && frames.length){
        const idx=Math.round(p*(frames.length-1));
        drawBmp(frames[idx]);
      }
      const seg=(a,b)=>Math.max(0,Math.min(1,(p-a)/(b-a)));
      caps.forEach(function(c){
        var fin=Math.max(0,Math.min(1,(p-c.a)/0.03));
        var fout=c.last?0:Math.max(0,Math.min(1,(p-(c.b-0.03))/0.03));
        var op=fin*(1-fout);
        c.el.style.opacity=op.toFixed(3);
        if(!c.last) c.el.style.transform='translateY('+((1-fin)*22).toFixed(1)+'px)';
        c.el.style.pointerEvents=op>0.5?'auto':'none';
      });
      if(finalBtns) finalBtns.classList.toggle('show', p>=0.93);
      if(hint) hint.style.opacity=(1-seg(.02,.1)).toFixed(3);
    }
    let raf=null;
    function onScroll(){ if(raf) return; raf=requestAnimationFrame(()=>{ raf=null; render(); }); }

    fit();
    window.addEventListener('resize',()=>{ fit(); render(); });
    window.addEventListener('scroll',onScroll,{passive:true});

    function staticPoster(){
      if(poster) poster.style.opacity='1';
      if(loading) loading.style.display='none';
      cine.style.height='100vh';
      render();
    }
    if(reduce){ staticPoster(); return; }

    /* ---- WebP sequence mode (production, real frames) ---- */
    if(SEQ.enabled){
      const set = isMobile ? {path:SEQ.pathMobile, count:SEQ.countMobile} : {path:SEQ.path, count:SEQ.count};
      const n = set.count; let loaded=0, errored=0;
      const done = ()=>{ ready=true; if(poster) poster.style.opacity='0'; if(loading) loading.style.display='none'; render(); };
      for(let k=0;k<n;k++){
        const idx=k+1;
        const img=new Image(); img.decoding="async";
        img.onload=async()=>{
          try{ frames[k]=await createImageBitmap(img); }catch(e){ frames[k]=img; }
          loaded++; if(loadingBar) loadingBar.style.width=Math.round((loaded+errored)/n*100)+'%';
          if(loaded===1) render();                 /* show first frame asap */
          if(loaded+errored>=n) done();
        };
        img.onerror=()=>{ errored++; if(loaded+errored>=n){ if(loaded>=8) done(); else staticPoster(); } };
        img.src=set.path+String(idx).padStart(4,'0')+SEQ.ext;
      }
      return;
    }

    /* ---- Video-decode mode ---- */
    const v=document.createElement('video');
    v.src=VIDEO_SRC; v.muted=true; v.playsInline=true; v.preload='auto';
    const off=document.createElement('canvas'); const octx=off.getContext('2d');
    let dur=0, i=0, failed=false;
    const timeout=setTimeout(()=>{ if(!ready){ failed=true; if(frames.filter(Boolean).length>8){ready=true;if(poster)poster.style.opacity='0';if(loading)loading.style.display='none';render();} else staticPoster(); } }, 14000);

    v.addEventListener('loadedmetadata',()=>{ dur=v.duration||10; fit(); seekNext(); });
    function seekNext(){ if(i>=N){ finish(); return; } try{ v.currentTime=Math.min(dur*0.999,(i/(N-1))*dur); }catch(e){ failed=true; staticPoster(); } }
    v.addEventListener('seeked', async ()=>{
      if(failed) return;
      const vw=v.videoWidth||1280, vh=v.videoHeight||720;
      const s=Math.min(1, DECODE_W/vw);
      off.width=Math.round(vw*s); off.height=Math.round(vh*s);
      octx.drawImage(v,0,0,off.width,off.height);
      try{ frames[i]=await createImageBitmap(off); }catch(e){ try{ const im=new Image(); im.src=off.toDataURL('image/jpeg',.85); frames[i]=im; }catch(_){} }
      if(i===0 && poster){ /* first frame ready: keep poster until all done */ }
      i++;
      if(loadingBar) loadingBar.style.width=Math.round(i/N*100)+'%';
      seekNext();
    });
    v.addEventListener('error',()=>{ failed=true; staticPoster(); });
    function finish(){ clearTimeout(timeout); ready=true; if(poster) poster.style.opacity='0'; if(loading) loading.style.display='none'; render(); }
  }

  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
})();
